import {
  ActionValidation,
  BooleanValidation,
  StringValidation,
} from '../../../../utils/component-validations';
import { on } from '@ember/modifier';
import GhostButton from '../../action/button/ghost.gjs';
import Super from '../../core/base.gjs';
import styles from './close.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class SpdsActionButtonClose extends Super {
  arguments = [
    new ActionValidation({ required: ['close'] }),
    new BooleanValidation({ optional: ['disabled'] }),
    new StringValidation({ optional: ['ariaLabel'] }),
  ];
  baseClass = 'spds-action-button-close';
  styles = styles;

  get ariaLabel() {
    return this.args.ariaLabel ?? 'close';
  }

  <template>
    <GhostButton
      @disabled={{@disabled}}
      @iconOnly={{true}}
      aria-label={{this.ariaLabel}}
      class={{this.classes}}
      data-test-spds-action-button-close
      type="button"
      {{this.validateArguments}}
      {{on "click" @close}}
      ...attributes
    >
      {{svgJar "x-mark" class="spds-action-button-close-icon"}}
    </GhostButton>
  </template>
}
